import React from 'react'
import PropTypes from 'prop-types'
import { ReactComponent as CalendarAddIcon } from 'images/icons/calendar-add.svg'

const CalendarBookSlotIcon = ({ className }) => (
  <CalendarAddIcon className={className} aria-hidden />
)

CalendarBookSlotIcon.propTypes = {
  className: PropTypes.string,
}

export default CalendarBookSlotIcon
